import { Box } from '@mui/material';
import React from 'react';

import NavbarItem, { NavbarItemInterface } from './NavbarItem';

export const navBarContentItemsCID = 'CID-NavBarContentItems';

interface NavbarNavigationsMenuProps {
  menuItems: NavbarItemInterface[];
}

const NavbarLeftItems = ({ menuItems }: NavbarNavigationsMenuProps): JSX.Element => {
  return (
    <Box
      className={navBarContentItemsCID}
      sx={{
        display: 'flex',
        // flexGrow: 1,
        flexWrap: 'wrap',
        height: '100%',
        maxHeight: '100%',
        overflow: 'hidden',
      }}
    >
      {menuItems.map((props) => (
        <NavbarItem key={props.path} {...props} />
      ))}
    </Box>
  );
};

export default NavbarLeftItems;
